// extracted by mini-css-extract-plugin
export var bold = "_rv-0";